// Languages: en (English), zh (Chinese), ja (Japanese), kr (Korean), fr (French), es (Spanish)
export function normalizeLocale(value) {
  const locale = String(value || '').trim().toLowerCase().replace(/_/g, '-');
  if (/^en(?:-|$)/.test(locale)) return 'en';
  if (/^zh(?:-|$)/.test(locale)) return 'zh';
  if (/^ja(?:-|$)/.test(locale)) return 'ja';
  if (/^(?:kr|ko)(?:-|$)/.test(locale)) return 'kr';
  if (/^fr(?:-|$)/.test(locale)) return 'fr';
  if (/^es(?:-|$)/.test(locale)) return 'es';
  return 'en';
}

export function getLanguage() {
  return normalizeLocale(localStorage.getItem('lang'));
}

export function clearSession() {
  // Only authentication is session data. Keep language and local preferences.
  // Revoke the server-side viewing session as well as the legacy local token.
  if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
    window.fetch('/api/video/endSession', { method: 'POST', credentials: 'same-origin', keepalive: true })
      .catch(() => { /* Local sign-out remains available while offline. */ });
  }
  const language = getLanguage();
  localStorage.removeItem('token');
  localStorage.setItem('lang', language);
}
